import { render, staticRenderFns } from "./myInheritorInfo.vue?vue&type=template&id=5eb24ae2&scoped=true&"
import script from "./myInheritorInfo.vue?vue&type=script&lang=js&"
export * from "./myInheritorInfo.vue?vue&type=script&lang=js&"
import style0 from "./myInheritorInfo.vue?vue&type=style&index=0&id=5eb24ae2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb24ae2",
  null
  
)

export default component.exports